import type { Configuration } from '@repo/api-gw-sdk';
import { ComplianceApi } from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/compliance/';

export const compliance = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const complianceApi = new ComplianceApi(config);

  return {
    useResources: (page = 0, pageSize = 2000) =>
      httpClient.execute(
        complianceApi.listComplianceResources.bind(complianceApi),
        baseUrl,
        `resources-${page}-${pageSize}`,
        currentProjectId,
        page,
        pageSize
      ),
  };
};
